import { render, staticRenderFns } from "./IntroductionPressPage.vue?vue&type=template&id=7357b80a&"
import script from "./IntroductionPressPage.vue?vue&type=script&lang=js&"
export * from "./IntroductionPressPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports